<template>
	<div class="attribute" ref='attribute'>
		<div class="settings clearfix" ref='settings'>
			<div class="settings_body clearfix" v-if="settingsShowMark">

				<div class="settings_box span clearfix">
					<!--名称-->
					<div class="settings_box_content clearfix" v-if="JSON.stringify(ThisActive)!= '{}'||(SyncJudge&&SyncType == 'conduit')">
						<div class="content_name">
							控件名称 :
						</div>
						<div class="content_body">
							<el-input ref="input" @focus="changefocus" @blur="changefocus" :title="dataAttr.divName" type="SpanName" placeholder="请输入名称" v-model="dataAttr.divName" maxlength="10" show-word-limit @input="NameChange"></el-input>
						</div>
					</div>

					<!--类型-->
					<div class="settings_box_content clearfix" v-if="JSON.stringify(ThisActive)!= '{}'" :style="{'border-bottom': ThisActive.type=='span'?'0px':'1px solid #151515'}">
						<div class="content_name">
							控件类型 :
						</div>
						<div class="content_body">
							<div class="content_body_span" v-if="ThisActive.type!='img'">{{ThisActive.name}}</div>
							<div class="content_body_span" v-if="ThisActive.type=='img'">设备</div>
						</div>
					</div>

					<!--用于控制文本标签显示内容   显示属性值or显示控件名称-->
					<div class="settings_box_content clearfix" v-if="(ThisActive.type=='span')&&JSON.stringify(ThisActive)!= '{}'">
						<div class="content_name">
							显示属性值 :
						</div>
						<div class="content_body stateLight">
							<el-switch v-model="dataAttr.spanShowValue" @change="showSpanTypeChange">
							</el-switch>
						</div>
					</div>
          <!-- 6.23新增判断 ThisActive.id==11 -->
					<!--转接头样式-->
					<div class="settings_box_content clearfix" v-if="(ThisActive.rotateDeg!=0||ThisActive.id==11)&&JSON.stringify(ThisActive)!= '{}'">
						<div class="conduit_css clearfix">
							<div class="conduit_css_name">{{ThisActive.id==10?'上端样式':ThisActive.id==11?'右端样式':'远端样式'}} :</div>
							<div class="conduit_css_body" Far-id='1' @click="FarShowClick">
								<div class="css_body_box NowFarBg" Far-id='1' :style="{'background-image': 'url('+ThisActive.FarEndImgUrl+')'}"></div>
								<img :class="{tranRotate:!ShowMarkFar}" src="../../../assets/image/editor/icon/deviceBottomMark.png" Far-id='1' />
							</div>
							<div class="ShowConduit FarEnd" v-if="ShowMarkFar" Far-id='1'>
								<!--x轴管道转接头列表-->
								<div class="ShowConduit_body clearfix" Far-id='1' v-if="ThisActive.rotateDeg=='-30'">
									<div class="ConduitChoiceBox" :class="{'active':item.id==ThisActive.FarNum}" v-for="(item,index) in FarOptions_30" :style="{'background-image': 'url('+item.url+')'}" Far-id='1' @click="FarAdapterChange(item.id)">
										<div class="boxChildren_name" Far-id='1'>
											{{item.name}}
										</div>
									</div>
								</div>

								<!--y轴管道转接头列表-->
								<div class="ShowConduit_body clearfix" Far-id='1' v-if="ThisActive.rotateDeg=='30'">
									<div class="ConduitChoiceBox" :class="{'active':item.id==ThisActive.FarNum}" v-for="(item,index) in FarOptions30" :style="{'background-image': 'url('+item.url+')'}" Far-id='1' @click="FarAdapterChange(item.id)">
										<div class="boxChildren_name" Far-id='1'>
											{{item.name}}
										</div>
									</div>
								</div>

								<!--z轴管道转接头列表-->
								<div class="ShowConduit_body clearfix" Far-id='1' v-if="ThisActive.rotateDeg=='90'&&ThisActive.id!=10">
									<div class="ConduitChoiceBox" :class="{'active':item.id==ThisActive.FarNum}" v-for="(item,index) in FarOptions90" :style="{'background-image': 'url('+item.url+')'}" Far-id='1' @click="FarAdapterChange(item.id)">
										<div class="boxChildren_name" Far-id='1'>
											{{item.name}}
										</div>
									</div>
								</div>

								<!--Y轴2d管道转接头列表-->
								<div class="ShowConduit_body clearfix" Near-id='1' v-if="ThisActive.rotateDeg=='90'&&ThisActive.id==10">
									<div class="ConduitChoiceBox" :class="{'active':item.id==ThisActive.FarNum}" v-for="(item,index) in FarOptions90_2d" :style="{'background-image': 'url('+item.url+')'}" Far-id='1' @click="FarAdapterChange(item.id)">
										<div class="boxChildren_name" Far-id='1'>
											{{item.name}}
										</div>
									</div>
								</div>

								<!--x轴2d管道转接头列表-->
								<div class="ShowConduit_body clearfix" Near-id='1' v-if="ThisActive.rotateDeg=='0'">
									<div class="ConduitChoiceBox" :class="{'active':item.id==ThisActive.FarNum}" v-for="(item,index) in FarOptions0" :style="{'background-image': 'url('+item.url+')'}" Far-id='1' @click="FarAdapterChange(item.id)">
										<div class="boxChildren_name" Far-id='1'>
											{{item.name}}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="conduit_css clearfix">
							<div class="conduit_css_name">{{ThisActive.id==10?'下端样式':ThisActive.id==11?'左端样式':'近端样式'}} :</div>
							<div class="conduit_css_body" Near-id='1' @click="NearShowClick">
								<div class="css_body_box NowNearBg" Near-id='1' :style="{'background-image': 'url('+ThisActive.NearEndImgUrl+')'}"></div>
								<img :class="{tranRotate:!ShowMarkNear}" src="../../../assets/image/editor/icon/deviceBottomMark.png" Near-id='1' />
							</div>
							<div class="ShowConduit NearEnd" Near-id='1' v-if="ShowMarkNear">
								<!--x轴管道转接头列表-->
								<div class="ShowConduit_body clearfix" Near-id='1' v-if="ThisActive.rotateDeg=='-30'">
									<div class="ConduitChoiceBox" :class="{'active':item.id==ThisActive.NearNum}" v-for="(item,index) in NearOptions_30" :style="{'background-image': 'url('+item.url+')'}" Near-id='1' @click="NearAdapterChange(item.id)">
										<div class="boxChildren_name" Near-id='1'>
											{{item.name}}
										</div>
									</div>
								</div>

								<!--y轴管道转接头列表-->
								<div class="ShowConduit_body clearfix" Near-id='1' v-if="ThisActive.rotateDeg=='30'">
									<div class="ConduitChoiceBox" :class="{'active':item.id==ThisActive.NearNum}" v-for="(item,index) in NearOptions30" :style="{'background-image': 'url('+item.url+')'}" Near-id='1' @click="NearAdapterChange(item.id)">
										<div class="boxChildren_name" Near-id='1'>
											{{item.name}}
										</div>
									</div>
								</div>

								<!--z轴管道转接头列表-->
								<div class="ShowConduit_body clearfix" Near-id='1' v-if="ThisActive.rotateDeg=='90'&&ThisActive.id!=10">
									<div class="ConduitChoiceBox" :class="{'active':item.id==ThisActive.NearNum}" v-for="(item,index) in NearOptions90" :style="{'background-image': 'url('+item.url+')'}" Near-id='1' @click="NearAdapterChange(item.id)">
										<div class="boxChildren_name" Near-id='1'>
											{{item.name}}
										</div>
									</div>
								</div>

								<!--Y轴2d管道转接头列表-->
								<div class="ShowConduit_body clearfix" Near-id='1' v-if="ThisActive.rotateDeg=='90'&&ThisActive.id==10">
									<div class="ConduitChoiceBox" :class="{'active':item.id==ThisActive.NearNum}" v-for="(item,index) in NearOptions90_2d" :style="{'background-image': 'url('+item.url+')'}" Near-id='1' @click="NearAdapterChange(item.id)">
										<div class="boxChildren_name" Near-id='1'>
											{{item.name}}
										</div>
									</div>
								</div>

								<!--x轴2d管道转接头列表-->
								<div class="ShowConduit_body clearfix" Near-id='1' v-if="ThisActive.rotateDeg=='0'">
									<div class="ConduitChoiceBox" :class="{'active':item.id==ThisActive.NearNum}" v-for="(item,index) in NearOptions0" :style="{'background-image': 'url('+item.url+')'}" Near-id='1' @click="NearAdapterChange(item.id)">
										<div class="boxChildren_name" Near-id='1'>
											{{item.name}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--管道颜色-->
					<div class="settings_box_content clearfix" v-if="((ThisActive.rotateDeg!=0||ThisActive.id==11)&&JSON.stringify(ThisActive)!= '{}')||(SyncJudge&&SyncType == 'conduit')">
						<div class="content_name">
							颜色选择 :
						</div>
						<div class="content_body">
							<el-select popper-class="el-selectDiy" v-model="dataAttr.colorId" filterable placeholder="请选择" @change="ConduitColorChange">
								<el-option v-for="(item,index) in conduitColorOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
					</div>

					<!--管道流动方向-->
					<div class="settings_box_content clearfix" v-if="((ThisActive.rotateDeg!=0||ThisActive.id==11)&&JSON.stringify(ThisActive)!= '{}')||(SyncJudge&&SyncType == 'conduit')">
						<div class="content_name">
							流动方向 :
						</div>
						<div class="content_body">
							<el-select popper-class="el-selectDiy" v-model="dataAttr.direction" filterable placeholder="请选择" @change="directionChange" v-if="ThisActive.id!=10&&ThisActive.id!=11">
								<el-option v-for="(item,index) in directionOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-select popper-class="el-selectDiy" v-model="dataAttr.direction" filterable placeholder="请选择" @change="directionChange" v-if="ThisActive.id==10">
								<el-option label="向下" :value="0"></el-option>
								<el-option label="向上" :value="1"></el-option>
							</el-select>
							<el-select popper-class="el-selectDiy" v-model="dataAttr.direction" filterable placeholder="请选择" @change="directionChange" v-if="ThisActive.id==11">
								<el-option label="向右" :value="0"></el-option>
								<el-option label="向左" :value="1"></el-option>
							</el-select>

						</div>
					</div>

					<!--关联设备-->
					<div class="settings_box_content clearfix" v-if="(ThisActive.type=='valve'||ThisActive.type=='watch'||ThisActive.type=='img')&&JSON.stringify(ThisActive)!= '{}'">
						<div class="content_name">
							关联设备 :
						</div>
						<div class="content_body">
							<el-select popper-class="el-selectDiy" v-model="dataAttr.DeviceId" filterable placeholder="请选择" @change="(val) => DeviceIdChange(val,'change')">
								<el-option v-for="(item,index) in DeviceOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
					</div>

					<!--关联属性 多选-->
					<div class="settings_box_content clearfix" v-if="ThisActive.type=='Divspan'&&JSON.stringify(ThisActive)!= '{}'">
						<div class="content_name">
							关联属性 :
						</div>
						<div class="content_body">
							<!--多选则在props添加multiple: true,在标签中添加collapse-tags-->
							<el-cascader
								popper-class="el-popperDiy"
								ref="spanDiv"
								v-model="dataAttr.DeviceMultipleArray"
								:options="DeviceOptions"
								:props="{multiple: true,expandTrigger: 'hover',value:'id',label:'name',emitPath: true,children:'children'}"
								collapse-tags
								:show-all-levels="false"
								@change="(val) => DeviceDataChangeS(val,'spanDiv')"
							>
							</el-cascader>️
						</div>
					</div>

					<!--关联属性 多选-->
					<div class="settings_box_content clearfix" style="border-bottom: 0px !important" v-if="ThisActive.type=='img'&&JSON.stringify(ThisActive)!= '{}'">
						<div class="content_name">
							设备面板关联属性
						</div>
						<div class="content_body">
							<!--:disabled="dataAttr.DeviceBlockArrayShow.length >= 10"-->
							<!--:multiple-limit="3"-->
							<!--多选则在props添加multiple: true,在标签中添加collapse-tags-->
							<el-cascader
								popper-class="el-popperDiy"
								v-model="dataAttr.DeviceBlockArrayShow"
								:options="ThisActive.DeviceAllAttrList"
								:props="{multiple: true,expandTrigger: 'hover',value:'identifier',label:'name',emitPath: true,}"
								collapse-tags
								:show-all-levels="false"
								@change="DeviceBlockChange"
							>
							</el-cascader>️
						</div>
					</div>

					<div v-if="dataAttr.spanShowValue||(ThisActive.type=='span'&&ThisActive.rotateDeg!=0)||ThisActive.type=='img'||ThisActive.rotateDeg!=0||(ThisActive.rotateDeg==0&&ThisActive.id==11)">
						<!--关联属性 不多选-->
						<div class="settings_box_content clearfix" :style="{'border-bottom':ThisActive.type=='span'?'0px':'1px solid #151515'}" v-if="(ThisActive.type=='span'||ThisActive.rotateDeg!=0||ThisActive.id==11)&&JSON.stringify(ThisActive)!= '{}'">
							<div class="content_name">
								关联属性 :
							</div>
							<div class="content_body">
								<!--不多选-->
								<el-cascader :title="DeviceDataTitle(dataAttr.DeviceData)" popper-class="el-popperDiy" ref="spanSon" v-model="dataAttr.DeviceData" :options="DeviceOptions" :props="{expandTrigger: 'hover',value:'id',label:'name',children:'children'}" @change="(val) => DeviceDataChange(val,'spanSon')">
								</el-cascader>
							</div>
						</div>

						<!--关联属性 是否展示属性名称 不多选的情况下-->
						<div class="settings_box_content clearfix" v-if="(ThisActive.type=='img'||ThisActive.type=='span')&&JSON.stringify(ThisActive)!= '{}'">
							<div class="content_name">
								显示属性名称 :
							</div>
							<div class="content_body stateLight">
								<el-switch v-model="dataAttr.showSpanName" @change="showSpanNameChange">
								</el-switch>
							</div>
						</div>
					</div>
					<!--文本标签样式-->
          <div v-if="dataAttr.spanShowValue||ThisActive.rotateDeg!=0||ThisActive.id==11">
          	<!--关联显示属性 不多选-->
          	<div class="settings_box_content clearfix" :style="{'border-bottom':ThisActive.type=='span'?'0px':'1px solid #151515'}" v-if="(ThisActive.type=='span'||ThisActive.rotateDeg!=0||ThisActive.id==11)&&JSON.stringify(ThisActive)!= '{}'">
          		<div class="content_name">
          			关联显示属性 :
          		</div>
          		<div class="content_body">
          			<!--不多选-->
          			<el-cascader :title="DeviceDataTitle(dataAttr.textShowData)" popper-class="el-popperDiy" v-model="dataAttr.textShowData"  ref="spanSon2" :options="DeviceShowOptions" :props="{expandTrigger: 'hover',value:'id',label:'name',children:'children'}" @change="(val) => changeTestShow(val,'spanSon2')">
                </el-cascader>
          		</div>
          	</div>

          	<!--关联显示属性 是否展示属性名称 不多选的情况下-->
          	<div class="settings_box_content clearfix" v-if="ThisActive.type=='span'&&JSON.stringify(ThisActive)!= '{}'">
          		<div class="content_name">
          			显示属性值 :
          		</div>
          		<div class="content_body">
                <el-select popper-class="el-selectDiy" v-model="dataAttr.showAttrKey" filterable placeholder="请选择" @change="(val) => changeShowAttrData(val,'spanSon2')">
                	<el-option v-for="(item,index) in showAttrData" :key="item.id" :label="item.name" :value="item.id">
                	</el-option>
                </el-select>
          		</div>
          	</div>
            <div class="settings_box_content clearfix" :style="{'border-bottom':ThisActive.type=='span'?'0px':'1px solid #151515'}" v-if="(ThisActive.type=='span'||ThisActive.rotateDeg!=0||ThisActive.id==11)&&JSON.stringify(ThisActive)!= '{}'">
            	<div class="content_name" style="text-align: left;padding-left: 26px;">
            		字体颜色 : <span class="color-span" :style="{backgroundColor:dataAttr.fontColor||'#FFF'}" @click="showColor(1)"></span>
            	</div>
              <!-- <div class="content_name" style="text-align: left;">
            		字体大小 :<el-input v-model="dataAttr.fontSize" style="width: 60px;height: 20px;"></el-input>
            	</div> -->
              <div class="content_name" style="text-align: left;padding-left: 18px;">
              	背景颜色 : <span class="color-span" :style="{backgroundColor:dataAttr.bgColor||'#607d8b'}" @click="showColor(2)"></span>
              </div>
            </div>
            <div class="settings_box_content clearfix" v-if="ThisActive.type=='span'&&JSON.stringify(ThisActive)!= '{}'">
            	<div class="content_name">
            		字体大小 :
            	</div>
            	<div class="content_body">
            		<el-select popper-class="el-selectDiy" v-model="dataAttr.fontSize" filterable placeholder="请选择" @change="changFontSize">
            			<el-option v-for="i in [12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]" :key="i" :label="i +'px'" :value="i">
            			</el-option>
            		</el-select>
            	</div>
            </div>
          </div>
					<!--报警灯开关-->
					<div class="settings_box_content clearfix" :style="{'border-bottom':ThisActive.type=='img'?'0px':'1px solid #151515'}" v-if="ThisActive.type=='img'&&ThisActive.propertie.hasAlarmLight&&JSON.stringify(ThisActive)!= '{}'">
						<div class="content_name">
							报警指示灯开关 :
						</div>
						<div class="content_body stateLight">
							<el-switch v-model="dataAttr.DeviceAlertLightShow" @change="(val) => DeviceLightChange(val,'DeviceAlertLight')">
							</el-switch>
						</div>
					</div>

					<!--状态指示灯开关-->
					<!--<div class="settings_box_content clearfix" :style="{'border-bottom':ThisActive.type=='img'?'0px':'1px solid #151515'}" v-if="ThisActive.DeviceCode.indexOf('_')!=0&&ThisActive.DeviceCode.indexOf('_')!=-1&&ThisActive.type=='valve'||ThisActive.type=='watch'||(ThisActive.type=='img'&&ThisActive.propertie.hasStateLight)&&JSON.stringify(ThisActive)!= '{}'">
						<div class="content_name">
							状态指示灯 :
						</div>
						<div class="content_body stateLight">
							<el-switch v-model="dataAttr.DeviceStateLightShow" @change="(val) => DeviceLightChange(val,'DeviceStateLight')">
							</el-switch>
						</div>
					</div>-->

					<!--开关机关联属性-->
					<div class="settings_box_content clearfix" v-if="ThisActive.type=='img'&&ThisActive.propertie.hasAlarmLight&&JSON.stringify(ThisActive)!= '{}'">
						<div class="content_name">
							开关机关联属性 :
						</div>
						<div class="content_body attrBottom">
							<el-select popper-class="el-selectDiy" v-model="dataAttr.DeviceAttrStateID" filterable placeholder="请选择" @change="StateAttrChange">
								<el-option v-for="(item,index) in ThisActive.DeviceAttrStateList" :key="index" :label="item.name" :value="item.identifier">
								</el-option>
							</el-select>
						</div>
					</div>

					<!--进度条开关-->
					<div class="settings_box_content clearfix" :style="{'border-bottom':ThisActive.type=='img'?'0px':'1px solid #151515'}" v-if="ThisActive.type=='img'&&ThisActive.propertie.hasProgressBar&&JSON.stringify(ThisActive)!= '{}'">
						<div class="content_name">
							进度条开关 :
						</div>
						<div class="content_body stateLight">
							<el-switch v-model="dataAttr.DeviceProgressLightShow" @change="(val) => DeviceLightChange(val,'DeviceProgressLight')">
							</el-switch>
						</div>
					</div>

					<!--进度条关联属性-->
					<div class="settings_box_content clearfix" v-if="ThisActive.type=='img'&&ThisActive.propertie.hasProgressBar&&JSON.stringify(ThisActive)!= '{}'">
						<div class="content_name">
							进度条关联属性 :
						</div>
						<div class="content_body attrBottom">
							<el-select popper-class="el-selectDiy" v-model="dataAttr.DeviceAttrID" filterable placeholder="请选择" @change="ProgressAttrChange">
								<el-option v-for="(item,index) in ThisActive.DeviceAttrList" :key="index" :label="item.name" :value="item.identifier">
								</el-option>
							</el-select>
						</div>
					</div>

					<!--管道阈值设置-->
					<div class="settings_box_content clearfix" v-if="(ThisActive.rotateDeg!=0||ThisActive.id==11)&&ThisActive.DevicePropCode!=null&&JSON.stringify(ThisActive)!= '{}'">
						<div class="content_name">
							阈值设置 :
						</div>
						<div class="content_body" v-if="ThisActive.DeviceAttrType.type=='enum'||ThisActive.DeviceAttrType.type=='bool'">
							<el-select popper-class="el-selectDiy" v-model="dataAttr.thresholdSymbol" filterable placeholder="请选择比较符" @change="SymbolEBChange">
								<el-option v-for="(item,index) in SymbolEBoptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
						<div class="content_body" style="margin-bottom: 10px;" v-if="ThisActive.DeviceAttrType.type=='enum'||ThisActive.DeviceAttrType.type=='bool'">
							<el-select popper-class="el-selectDiy" v-model="dataAttr.thresholdValue" filterable placeholder="请选择" @change="ValueChangeOptionArray">
								<el-option v-for="(item,index) in ThisActive.ValueOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
						<div class="content_body" v-if="ThisActive.DeviceAttrType.type!='enum'&&ThisActive.DeviceAttrType.type!='bool'">
							<el-select popper-class="el-selectDiy" v-model="dataAttr.thresholdSymbol" filterable placeholder="请选择比较符" @change="SymbolIDFChange">
								<el-option v-for="(item,index) in SymbolIDFoptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
						<div class="content_body" style="margin-bottom: 10px;" v-if="ThisActive.DeviceAttrType.type!='enum'&&ThisActive.DeviceAttrType.type!='bool'">
							<el-input type="SpanName" placeholder="请输入比较值" v-model="dataAttr.thresholdValue" show-word-limit @input="ValueChangeOptionText"></el-input>
							<div class="el-form-item__errorMy" :class="{active:errorMy}">
								{{errorMyText}}
							</div>
						</div>
					</div>

				</div>
			</div>

      <div class="settings_body clearfix" v-if="(GridSettingShow||JSON.stringify(ThisActive)== '{}')&&mapType==1">
        <div class="settings_box span clearfix">
        <!-- 背景设置 -->
        <div class="settings_box_content clearfix" :style="{'border-bottom':false?'0px':'1px solid #151515'}">
        	<div class="content_name" style="text-align: left;padding-left: 45px;">
          	背景颜色3 : <span class="color-span" :style="{backgroundColor:MapBgData&&MapBgData.bgColor?MapBgData.bgColor:'#151515'}" @click="showColor(3)"></span>
          </div>
        </div>
        </div>
      </div>
    </div>
		<div class="components clearfix" ref="components">
			<div class="drag_top" @mousedown="mouseDown"></div>
			<div class="components_header">组件大纲</div>
			<div class="components_body clearfix">
				<div class="components_name" :class="{active:item.active}" v-for="(item,index) in draggable" v-if="item.ShowActive" @click="componentsClick(item.index,item.active)">
					{{item.divName}}
				</div>
			</div>
		</div>
    <div style="position: fixed; top: 0;left: 0;width: 100%;bottom: 0; z-index: 1000;" @click="colorMark=false" v-show="colorMark">
    </div>
    <sketch-picker @click.stop="showssss(1)" class="vueColor" :disableAlpha="disableAlpha" v-show="colorMark" :style="{'top': colorTop+'px','left': colorLeft+'px'}" v-model="color"  @input="colorInputClick" ></sketch-picker>

	</div>
</template>

<script>
	import { mapState } from 'vuex';
	import { mapMutations } from 'vuex';
  import { Sketch } from 'vue-color'
	export default {
		name: 'Home',
		data() {
			return {
				//取色器当前x,y坐标 开关
				colorTop: 0,
				colorLeft: 0,
        colorMark:false,
        disableAlpha:true,
        colorType:1,
        color:'#ff0000',
				//存放data值
				dataAttr: {
					divName: '',//控件名称
					colorId: null,//控件颜色
					direction: null,//管道流动方向
					DeviceId: null,//控件关联设备
					DeviceMultipleArray: [],//控件关联属性 多选
					//DeviceBlockArray: [],//设备面板关联属性 多选
					DeviceBlockArrayShow: [],//设备面板关联属性 用于展示
					DeviceData: [],//控件关联属性 单选
					DeviceAlertLightShow: false,//控件报警指示灯开关
					DeviceStateLightShow: false,//控件状态指示灯开关
					DeviceAttrStateID:null,//控件开关机关联属性
					DeviceProgressLightShow: false,//进度条开关
					DeviceAttrID: null,//进度条开关关联属性
					thresholdSymbol: null,//当前阈值选择符id
					thresholdValue: null,//当前阈值输入值
          DeviceShowCode:null,
          showAttrKey:null,
          textShowData:[],
          fontSize:null,
          fontColor:'#ff0000',
          bgColor:null,
				},

				value: true,

				ThisActive: {}, //当前首选的控件

				//原始demo数据
				zIndex: 0,
				NearAdapter: null,
				FarAdapter: null,

				settingsShowMark: false, //属性配置 是否显示

				SyncJudge: false, //当前是否处于多选状态
				SyncType: null, //当前多选状态下的控件类型 如果多选为不同类型 则为null

				ActiveType: null, //当前选中的控件类型

				/*公共配置*/

				DeviceOptions: [], //设备列表 以及关联属性
        DeviceShowOptions:[],
        showAttrData:[],
				ProductList: [], //产品列表

				errorMy: false, //错误提示开关
				errorMyText: '', //错误提示文本

				//所关联的设备属性 类型为int或float或double时 比较符数组
				SymbolIDFoptions: [{
					id: 0,
					name: '>'
				}, {
					id: 1,
					name: '>='
				}, {
					id: 2,
					name: '=='
				}, {
					id: 3,
					name: '<'
				}, {
					id: 4,
					name: '<='
				}, {
					id: 5,
					name: '!='
				}, {
					id: 6,
					name: 'in'
				}, {
					id: 7,
					name: 'between'
				}],

				//所关联的设备属性 类型为enum或bool时 比较符数组
				SymbolEBoptions: [{
					id: 0,
					name: '=='
				}],

				//管道颜色
				conduitColorOptions: [{
					id: 1,
					name: '灰色',
				}, {
					id: 2,
					name: '红色',
				}, {
					id: 3,
					name: '蓝色',
				}, {
					id: 4,
					name: '绿色',
				}, {
					id: 5,
					name: '橙色',
				}],

				//转接头
				NearOptions_30: [], //x
				NearOptions30: [], //y
				NearOptions90: [], //z
				FarOptions_30: [], //x
				FarOptions30: [], //y
				FarOptions90: [], //z
        NearOptions90_2d:[],
        FarOptions90_2d:[],
        NearOptions0:[],
        FarOptions0:[],

				/*-------------------------------------*/

				//type:Divspan
				moth: [],

				directionOptions: [{
					id: 0,
					name: '近端'
				},{
					id: 1,
					name: '远端'
				}], //管道流动方向

				//type:valve||type:watch
				DeviceLightState: 1, //状态指示灯的状态 (mqtt)
			}
		},
		components: {
			'sketch-picker': Sketch
		},
    props:{
      GridSettingShow: {
        type: Boolean,
        default: false,
      },
			mapType: {
				type: Number,
				request: 2
			},
    },
		computed: {
			...mapState("defaultImgOptions", {
				currentIndex: 'currentIndex',
				draggable: 'draggable',
				sync: 'sync',
				ShowMarkNear: 'ShowMarkNear',
				ShowMarkFar: 'ShowMarkFar',
				adapter: 'adapter',
        MapBgData:"MapBgData",
			}),
			DeviceDataTitle() {
				return (arr) => {
					if(!arr || arr.length == 0) return ;
					let device = this.DeviceOptions.filter(item => item.id == arr[0])[0];
					if(device){
						let attr = device.children.filter(item => item.id == arr[1])[0];
						attr = attr||{};
						attr.name = attr.name||''
						return device.name + ' / ' + attr.name
					}else{
						return ''
					}

				}
			},
			companyId() {
				return this.$store.state.companyId;
			},

			monitorDeviceId() {
				return this.dataAttr.DeviceId;
			},
		},
		mounted() {
			var self = this;

			/*setTimeout(() => {
				self.inputBlur();
			},3000)*/

			/*配置各个管道的转接头列表*/
			for(var a = 0; a < this.adapter.length; a++) {
				for(var i = 0; i < this.adapter[a].allowType.length; i++) {
					var name = this.adapter[a].allowType[i].name;
					var type = this.adapter[a].allowType[i].type
					if(name == 'conduit-30') {
						if(type.includes('N')) {
							this.NearOptions_30.push(this.adapter[a]);
						}
						if(type.includes('F')) {
							this.FarOptions_30.push(this.adapter[a]);
						}
					} else if(name == 'conduit30') {
						if(type.includes('N')) {
							this.NearOptions30.push(this.adapter[a]);
						}
						if(type.includes('F')) {
							this.FarOptions30.push(this.adapter[a]);
						}
					} else if(name == 'conduit90') {
						if(type.includes('N')) {
							this.NearOptions90.push(this.adapter[a]);
						}
						if(type.includes('F')) {
							this.FarOptions90.push(this.adapter[a]);
						}
					}else if(name == 'conduit90_2d') {
						if(type.includes('N')) {
							this.NearOptions90_2d.push(this.adapter[a]);
						}
						if(type.includes('F')) {
							this.FarOptions90_2d.push(this.adapter[a]);
						}
					}else if(name == 'conduit0') {
						if(type.includes('N')) {
							this.NearOptions0.push(this.adapter[a]);
						}
						if(type.includes('F')) {
							this.FarOptions0.push(this.adapter[a]);
						}
					}
				}
			}
      console.log(this.adapter,this.NearOptions90,this.FarOptions90)
			this.init();


		},
		methods: {
			...mapMutations("defaultImgOptions", {
				zIndexTop: 'zIndexTop',
				zIndexBottom: 'zIndexBottom',
				zIndexUpdata: 'zIndexUpdata',
				NearAdapterUpdata: 'NearAdapterUpdata',
				FarAdapterUpdata: 'FarAdapterUpdata',
				NearAdapterClear: 'NearAdapterClear',
				FarAdapterClear: 'FarAdapterClear',
				currentIndexModify: 'currentIndexModify',
				ActiveForDraggable: 'ActiveForDraggable',
				ActiveForDraggableAllFalse: 'ActiveForDraggableAllFalse',
				NowActiveModifyTrue: 'NowActiveModifyTrue',
				DivNameChange: 'DivNameChange',
				NearShowClick: 'NearShowClick',
				FarShowClick: 'FarShowClick',
				conduitColorChange: 'conduitColorChange',
				DevicePropUpdata: 'DevicePropUpdata',
        TextShowData: 'TextShowData',
        TextStyleData: 'TextStyleData',
				AgainLodingConnectPoint: 'AgainLodingConnectPoint',
				DevicePropMultipleUpdata: 'DevicePropMultipleUpdata',
				DeviceLightShowUpdata: 'DeviceLightShowUpdata',
				DeviceIdUpdata: 'DeviceIdUpdata',
				DevicePropMothUpdata: 'DevicePropMothUpdata',
				ProductCodeUpdata: 'ProductCodeUpdata',
				DeviceAttrTypeUpdata: 'DeviceAttrTypeUpdata',
				ClearThreshold: 'ClearThreshold',
				thresholdMarkChange: 'thresholdMarkChange',
				ValueOptionsUpdata: 'ValueOptionsUpdata',
				DeviceAttrValueUpdata: 'DeviceAttrValueUpdata',
				revokeStorage: 'revokeStorage',
				directionUpdata: 'directionUpdata',
				DeviceAttrStateValueUpdata: 'DeviceAttrStateValueUpdata',
				inputFocusChange: 'inputFocusChange',
				showSpanNameUpdata: 'showSpanNameUpdata',
				showSpanTypeUpdata: 'showSpanTypeUpdata',
				DeviceBlockArrayUpdata: 'DeviceBlockArrayUpdata'
			}),
      showssss(i){
        console.log(i)
      },
      // 颜色组件
      showColor(type){
        this.colorType=type
       if(type==1){
         this.disableAlpha = true
         this.color = this.dataAttr.fontColor||'#ffffff'
       }else if(type==2){
         this.disableAlpha = false
         this.color = this.dataAttr.bgColor||"#607d8bFF"
       }else{
         this.disableAlpha = true
         this.color = this.MapBgData.bgColor||"#151515"
       }
       console.log(this.color)
       this.colorMark = true
       //将色板定位值鼠标位置
       let e = window.event || arguments[0];
       let colorTop = e.clientY - 74, //减去导航栏的高度 则为当前布局绝对定位的y轴
       	colorLeft = e.clientX;
       //判断当前色板是否超出屏幕范围 色板高度为309px(固定) 宽度220px(固定)
       if(e.clientY + 309 > window.innerHeight) {
       	colorTop = e.clientY - 74 - 309
       }
       if(e.clientX + 230 > window.innerWidth) {
       	colorLeft = e.clientX - 230
       }
       this.colorTop = colorTop;
       this.colorLeft = colorLeft;
       this.$forceUpdate()
      },
      colorInputClick(e){
        if(this.colorType==1){
          this.dataAttr.fontColor = e.hex
        }else if(this.colorType==2){
          this.dataAttr.bgColor = e.hex8
        }else{
          this.MapBgData.bgColor = e.hex
        }
      },
      changFontSize(){
        let obj ={
          fontSize:this.dataAttr.fontSize
        }
        this.TextStyleData(obj)
        this.$emit('updata')
        this.$forceUpdate()
      },
			/*组件大纲拖拽*/
			mouseDown(event){
				let self = this;
				let evt = window.event || arguments[0];
				let startY = (evt.y || evt.clientY);
				let fatherHeight = self.$refs.attribute.offsetHeight;
				let startHeight = self.$refs.components.offsetHeight;
				let broHeight = self.$refs.settings.offsetHeight;
				const drag = () => {
					evt = window.event || arguments[0];
					let _y = (evt.y || evt.clientY);
					let delY = _y - startY;//差值
					let NewHeight = startHeight - delY;
					if(NewHeight >= fatherHeight){
						NewHeight = fatherHeight;
					}else if(NewHeight <= 44){
						NewHeight = 44;
					}
					self.$refs.components.style.height = NewHeight + 'px';
					self.$refs.settings.style.height = fatherHeight - NewHeight + 'px';
				}
				const up = () => {

					document.removeEventListener('mousemove', drag);
					document.removeEventListener('mouseup', up);
				}
				document.addEventListener('mousemove', drag);
				document.addEventListener('mouseup', up);
			},
			async init(){
				let self = this;
				/*配置关联设备关联属性列表*/
				await self.getProductList();
				let res = await this.getHistoryData();
				self.DeviceOptions = res.result.filter(item => item.propertySet.split(',')[0] != '');
				await self.realDeviceinit();
				self.virtualDeviceinit();
			},

			/*获取所有产品列表*/
			getProductList(){
				return new Promise((resolve) => {
					this.get('/Product/getList').then((res) => {
						if(res.success) {
							this.ProductList = res.result;
							resolve();
						}
					})
				})
			},

			/*获取指定公司的设备列表*/
			getHistoryData(){
				let self = this;
				return new Promise((resolve, reject) => {
					self.get('/Device/getList', {
						companyId: self.companyId
					}).then((res) => {
						if(res.success == true) {
							resolve(res)
						}
					})
				})
			},

			/*配置虚拟设备*/
			virtualDeviceinit(){
				let self = this;
				/*虚拟设备设备与属性列表push*/
				self.get('/VirtualDevice/get', {
					companyId: self.companyId
				}).then((res) => {
					if(res.success == true) {
						let data = res.result;
						data.type = 'Virtual';
						data.DataName = data.name;
						data.name = '虚拟设备'
						if(!data.id&&data.id!=0){ return }
						self.get('/VirtualDevice/getPropertyList', {
							deviceId: data.id
						}).then((res) => {
							if(res.success == true) {
								data.children = res.result;
								for(let a of data.children){
									a.id = a.code + '-' + data.id;
								}
								self.DeviceOptions.push(data);
							}
						})
					}
				})
			},

			/*配置设备列表*/
			realDeviceinit(){
				let self = this;
				return new Promise((resolve, reject) => {
					let index = 0;
					if(self.DeviceOptions.length == 0)resolve();
					for(let DeviceOptions of self.DeviceOptions) {
						let propList = DeviceOptions.propertySet.split(',');//属性数组
						self.get('/ProductFeature/getByDeviceCode', {
							code: DeviceOptions.code
						}).then((res) => {
							if(res.success == true) {
								let data = JSON.parse(res.result).properties;
								let arr = [];
								for(let list of propList){
									for(let dataList of data){
										if(list == dataList.identifier){
											dataList.id = dataList.identifier + '-' + DeviceOptions.code
											arr.push(dataList);
										}
									}
								}
								DeviceOptions.children = arr
							}
						})
						index++;
						if(index == self.DeviceOptions.length){
							resolve();
						}
					}
				});
			},

			//流动方向改变
			directionChange(val){
				this.revokeStorage();/*存储撤消状态*/
				this.directionUpdata(val)
        // this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},

			//比较符变更时
			SymbolEBChange(val) {
				this.revokeStorage();/*存储撤消状态*/
				this.draggable.filter(item => item.index == this.currentIndex)[0].thresholdSymbol = val;
				if(this.ThisActive.thresholdSymbol === 0) {
					if(Number(this.ThisActive.thresholdValue) == Number(this.ThisActive.DevicePropValue)) {
						this.thresholdMarkChange('true')
					} else {
						this.thresholdMarkChange('false')
					}
				}
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},
			SymbolIDFChange(val) {
				this.revokeStorage();/*存储撤消状态*/
				this.draggable.filter(item => item.index == this.currentIndex)[0].thresholdSymbol = val;
				let NowValue = this.ThisActive.thresholdValue;
				let PropValue = Number(this.ThisActive.DevicePropValue);
				let ThisActive = this.ThisActive;
				this.thresholdMarkChange('false')
				this.errorMy = false;
				this.errorMyText = '';

				let min = Number(ThisActive.DeviceAttrType.specs.min);
				let max = Number(ThisActive.DeviceAttrType.specs.max);
				//正则修正输入值
				if(ThisActive.thresholdSymbol == 6 || ThisActive.thresholdSymbol == 7) {
					NowValue = '[' + NowValue.replace(/[^\-?\d.,]/g, "").replace(/\[/g, "").replace(/\]/g, "").replace(/,,/g, ",") + ']';
					if(NowValue.split(']')[0].split('')[NowValue.split(']')[0].split('').length - 1] != ',') { //防止多','报错
						let NowValueArr = JSON.parse(NowValue);
						for(var a = 0; a < NowValueArr.length; a++) { //判断最大值最小值
							if(NowValueArr[a] < min) {
								NowValueArr[a] = min
							} else if(NowValueArr[a] > max) {
								NowValueArr[a] = max
							}
						}
						if(ThisActive.thresholdSymbol == 7 && NowValueArr.length > 2) { //between只能输入两个
							let NewArrTwoLength = [];
							NewArrTwoLength.push(NowValueArr[0])
							NewArrTwoLength.push(NowValueArr[1])
							NowValue = JSON.stringify(NewArrTwoLength)
						} else {
							NowValue = JSON.stringify(NowValueArr);
						}
					}
				} else {
					if(NowValue.indexOf('[') != -1) { //将从6,7转为1~5时清空阈值
						NowValue = '';
					} else {
						NowValue = NowValue.replace(/[^\-?\d.]/g, "").replace(/\.{2,}/g, ".").replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/^\./g, "").replace(/--/g, "-").replace(/[\d]-/g, "");
						if(Number(NowValue) < min) {
							NowValue = String(min)
						} else if(Number(NowValue) > max) {
							NowValue = String(max)
						}
					}
				}

				if(ThisActive.thresholdSymbol == 0) {
					// >
					if(PropValue > NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 1) {
					// >=
					if(PropValue >= NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 2) {
					// ==
					if(PropValue == NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 3) {
					// <
					if(PropValue < NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 4) {
					// <=
					if(PropValue <= NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 5) {
					// !=
					if(PropValue != NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 6) {
					//in
					if(NowValue.split(']')[0].split('')[NowValue.split(']')[0].split('').length - 1] != ',') { //阻止报错
						let NowValueArr = JSON.parse(NowValue);
						for(let num of NowValueArr) {
							if(num == PropValue) {
								this.thresholdMarkChange('true')
							}
						}
					}
				} else if(ThisActive.thresholdSymbol == 7) {
					//between
					if(NowValue.split(']')[0].split('')[NowValue.split(']')[0].split('').length - 1] != ',') { //阻止报错
						let NowValueArr = JSON.parse(NowValue);
						if(NowValueArr[0] > NowValueArr[1]) {
							this.errorMy = true;
							this.errorMyText = '比较值填写错误,第一个值需小于第二个值'
						} else if(Number(PropValue) > Number(NowValueArr[0]) && Number(PropValue) < Number(NowValueArr[1])) {
							this.thresholdMarkChange('true')
						}
					}
				}
				this.draggable.filter(item => item.index == this.currentIndex)[0].thresholdValue = NowValue;
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},

			//阈值变更时
			ValueChangeOptionArray(val) {
				this.revokeStorage();/*存储撤消状态*/
				this.draggable.filter(item => item.index == this.currentIndex)[0].thresholdValue = val;
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},
			ValueChangeOptionText(val) {
				this.revokeStorage();/*存储撤消状态*/
				let NowValue = val;
				let PropValue = Number(this.ThisActive.DevicePropValue);
				let ThisActive = this.ThisActive;
				this.thresholdMarkChange('false')
				this.errorMy = false;
				this.errorMyText = '';

				let min = Number(ThisActive.DeviceAttrType.specs.min);
				let max = Number(ThisActive.DeviceAttrType.specs.max);
				//正则修正输入值
				if(ThisActive.thresholdSymbol == 6 || ThisActive.thresholdSymbol == 7) {
					NowValue = '[' + NowValue.replace(/[^\-?\d.,]/g, "").replace(/\[/g, "").replace(/\]/g, "").replace(/,,/g, ",") + ']';
					if(NowValue.split(']')[0].split('')[NowValue.split(']')[0].split('').length - 1] != ',') {
						let NowValueArr = JSON.parse(NowValue);
						for(var a = 0; a < NowValueArr.length; a++) {
							if(NowValueArr[a] < min) {
								NowValueArr[a] = min
							} else if(NowValueArr[a] > max) {
								NowValueArr[a] = max
							}
						}
						if(ThisActive.thresholdSymbol == 7 && NowValueArr.length > 2) {
							let NewArrTwoLength = [];
							NewArrTwoLength.push(NowValueArr[0])
							NewArrTwoLength.push(NowValueArr[1])
							NowValue = JSON.stringify(NewArrTwoLength)
						} else {
							NowValue = JSON.stringify(NowValueArr);
						}
					}
				} else {
					NowValue = NowValue.replace(/[^\-?\d.]/g, "").replace(/\.{2,}/g, ".").replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/^\./g, "").replace(/--/g, "-").replace(/[\d]-/g, "");
					if(Number(NowValue) < min) {
						NowValue = String(min)
					} else if(Number(NowValue) > max) {
						NowValue = String(max)
					}
				}

				if(ThisActive.thresholdSymbol == 0) {
					// >
					if(PropValue > NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 1) {
					// >=
					if(PropValue >= NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 2) {
					// ==
					if(PropValue == NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 3) {
					// <
					if(PropValue < NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 4) {
					// <=
					if(PropValue <= NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 5) {
					// !=
					if(PropValue != NowValue) {
						this.thresholdMarkChange('true')
					}
				} else if(ThisActive.thresholdSymbol == 6) {
					//in
					if(NowValue.split(']')[0].split('')[NowValue.split(']')[0].split('').length - 1] != ',') {
						let NowValueArr = JSON.parse(NowValue);
						for(let num of NowValueArr) {
							if(num == PropValue) {
								this.thresholdMarkChange('true')
							}
						}
					}
				} else if(ThisActive.thresholdSymbol == 7) {
					//between
					if(NowValue.split(']')[0].split('')[NowValue.split(']')[0].split('').length - 1] != ',') {
						let NowValueArr = JSON.parse(NowValue);
						if(NowValueArr[0] > NowValueArr[1]) {
							this.errorMy = true;
							this.errorMyText = '比较值填写错误,第一个值需小于第二个值'
						} else if(Number(PropValue) > Number(NowValueArr[0]) && Number(PropValue) < Number(NowValueArr[1])) {
							this.thresholdMarkChange('true')
						}
					}
				}
				this.draggable.filter(item => item.index == this.currentIndex)[0].thresholdValue = NowValue;
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},

			/*关联设备改变*/
			DeviceIdChange(val,type) {
				let ThisActive = this.ThisActive;

				/*重置关于属性的状态*/
				if(type == 'change'){
					this.draggable.filter(item => item.index == this.currentIndex)[0].DeviceAttrID = null;//进度条关联属性
					this.draggable.filter(item => item.index == this.currentIndex)[0].DeviceAttrStateID = null;//开关机关联属性
					this.draggable.filter(item => item.index == this.currentIndex)[0].DeviceBlockArray = [];//设备面板关联属性
					this.draggable.filter(item => item.index == this.currentIndex)[0].DeviceBlockArrayShow = [];//设备面板关联属性

					this.revokeStorage();/*存储撤消状态*/
				}
				this.draggable.filter(item => item.index == this.currentIndex)[0].DeviceAttrList = null;//进度条关联属性列表
				this.draggable.filter(item => item.index == this.currentIndex)[0].DeviceAttrStateList = [];//开关机关联属性列表
				this.draggable.filter(item => item.index == this.currentIndex)[0].DeviceAllAttrList = [];//存放当前关联设备的所有属性

				for(let Options of this.DeviceOptions) {
					if(Options.id == val) { //拿到选中的设备对象
						let attrOptions = Options.children; //拿到选中的设备对象的属性列表
						let attrlist = []; //存放当前所关联设备的所有属性
						let attrlistArr = []; //存放当前可选进度条属性列表
						let attrStatelistArr = []; //存放当前可选开关机属性
						if(Options.name == '虚拟设备'){
							/*虚拟设备*/
							this.DeviceIdUpdata({
								DeviceID: Options.id,
								DeviceCode: Options.code,
								DeviceName: Options.name,
								DeviceAllAttrList: attrlist,
								DeviceAttrList: attrlistArr,
								DeviceAttrStateList: attrStatelistArr,
							})
							if(type){
								this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
							}
						}else{
							/*真实设备*/
							this.get('/ProductFeature/getByDeviceCode', {
								code: Options.code
							}).then((res) => {
								if(res.success) {
									let dataList = JSON.parse(res.result).properties;
									for(let attrOption of attrOptions) {
										for(let featureList of dataList) {
											if(featureList.identifier == attrOption.id.split('-')[0]) {
												featureList.identifier == attrOption.id;
												featureList.value = attrOption.value
												if(featureList.dataType.type == 'int' || featureList.dataType.type == 'float' || featureList.dataType.type == 'double') {
													attrlistArr.push(featureList)
												} else if(featureList.dataType.type == 'bool') {
													attrStatelistArr.push(featureList)
												}
												attrlist.push(featureList)
											}
										}
									}
									this.DeviceIdUpdata({
										DeviceID: Options.id,
										DeviceCode: Options.code,
										DeviceName: Options.name,
										DeviceAllAttrList: attrlist,
										DeviceAttrList: attrlistArr,
										DeviceAttrStateList: attrStatelistArr,
									})
									if(type){
										this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
									}
								}
							})
						}
					}
				}
			},

			/*进度条属性点击*/
			ProgressAttrChange(val) {
				this.revokeStorage();/*存储撤消状态*/
				/*保存选中属性*/
				this.DeviceAttrValueUpdata({
					DeviceAttrID: val
				})
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},

			/*开关机属性点击*/
			StateAttrChange(val) {
				this.revokeStorage();/*存储撤消状态*/
				/*保存选中属性*/
				this.DeviceAttrStateValueUpdata({
					DeviceAttrStateID: val,
				})
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},

			/*状态指示灯开关*/
			DeviceLightChange(val, name) {
				this.revokeStorage();/*存储撤消状态*/
				this.DeviceLightShowUpdata({
					val: val,
					name: name,
					state: this.DeviceLightState
				})
//				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},

			/*显示属性名称开关*/
			showSpanNameChange(val){
				this.revokeStorage();/*存储撤消状态*/
				this.showSpanNameUpdata(val)
				this.$forceUpdate()
				//this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},

			/*显示属性值开关 用于控制文本标签显示内容*/
			showSpanTypeChange(val){
				this.revokeStorage();/*存储撤消状态*/
				this.showSpanTypeUpdata(val)
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
				this.$forceUpdate()
			},

			/*管道颜色改变*/
			ConduitColorChange(val) {
				this.revokeStorage();/*存储撤消状态*/
				this.conduitColorChange(val)
			},

      changeTestShow(val,refName,set,attrKey){
        if(attrKey){
          this.dataAttr.showAttrKey = attrKey
        }else{
          this.dataAttr.showAttrKey = null
        }
        let DataNode = this.$refs[refName].getCheckedNodes()[0] //选中设备数组
        let selectData = [];
        if(DataNode){
          Object.keys(DataNode.data.dataType.specs).forEach(function(key) {
          	let devObj = {};
          	devObj.id = key;
          	devObj.name = DataNode.data.dataType.specs[key];
          	selectData.push(devObj);
          });
        }
        this.showAttrData = selectData
        if(set){
          this.DeviceOptions2()
        }
        this.$forceUpdate()
      },
      changeShowAttrData(val, refName){
        if(!val){ return }
        this.revokeStorage();/*存储撤消状态*/
        let DataNode = this.$refs[refName].getCheckedNodes()[0] //选中设备数组
        let obj={
          DeviceShowCode:DataNode.parent.data.code,
          attrIdentifier:DataNode.data.identifier,
          showAttrKey:val,
          textShowData:[DataNode.parent.value,DataNode.value]
        }
        this.TextShowData(obj)
        this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
      },
			/*单选关联属性改变*/
			DeviceDataChange(val, refName) {
				this.revokeStorage();/*存储撤消状态*/
				let DataNode = this.$refs[refName].getCheckedNodes()[0] //选中设备数组
				let DeviceProductID = DataNode.parent.data.productId; //选中设备的产品id
				let DeviceId = DataNode.parent.value; //选中设备id
				let DeviceCode = DataNode.value.split('-')[1];//选中设备Code
				let DeviceName = DataNode.parent.label; //选中设备名称
				let DevicePropCode = DataNode.value; //选中设备属性code
				let DevicePropName = DataNode.label; //选中设备属性name
				let DevicePropValue = DataNode.data.value; //选中设备属性value
				let DeviceData = [DeviceId, DevicePropCode];
				var obj = {
					DeviceId: DeviceId,
					DeviceCode: DeviceCode,
					DevicePropCode: DevicePropCode,
					DeviceName: DeviceName,
					DevicePropValue: DevicePropValue,
					DevicePropName: DevicePropName,
					DeviceData: DeviceData,
				}
				this.DevicePropUpdata(obj)

				//设置所关联的设备的产品code
				if(this.ThisActive.rotateDeg != 0||this.ThisActive.id == 11) {
					for(let propList of this.ProductList) {
						if(propList.id == DeviceProductID) {
							this.ClearThreshold();
							this.ProductCodeUpdata(propList.code);
							this.productFeatureGet(propList.code, DevicePropCode);
						}
					}
				}
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},
			/*多选关联属性改变*/
			DeviceDataChangeS(val, refName) {
				this.revokeStorage();/*存储撤消状态*/
				let data = this.$refs[refName].getCheckedNodes();
				let CheckedArr = [];
				for(var a = 0; a < data.length; a++) {
					if(data[a].parent != null) {
						CheckedArr.push({
							DeviceId: data[a].parent.data.id,
							DeviceName: data[a].parent.data.name,
							DeviceCode: data[a].parent.data.code,
							productId: data[a].parent.data.productId,
							attrData: data[a].data,
						})
					}
				}
				CheckedArr = this.ArrayMoth(CheckedArr); //数组分类
				let ProductList = this.ProductList;
				for(var n = 0; n < CheckedArr.length; n++) {
					for(var m = 0; m < ProductList.length; m++) {
						if(CheckedArr[n].productId == ProductList[m].id) {
							CheckedArr[n].productName = ProductList[m].name;
							CheckedArr[n].productCode = ProductList[m].code;
						}
					}
				}
				this.DevicePropMothUpdata(CheckedArr)
				this.DevicePropMultipleUpdata(val);
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},

			/*设备面板关联属性改变*/
			DeviceBlockChange(val){
				this.revokeStorage();/*存储撤消状态*/
				this.DeviceBlockArrayUpdata(val)
				//this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},

			/*获取对应设备的产品物模型 保存关联属性类型*/
			productFeatureGet(DeviceCode, AttrCode) {
				this.get('/ProductFeature/get', {
					code: DeviceCode
				}).then((res) => {
					if(res.success) {
						let data = JSON.parse(res.result).properties;
						for(let propList of data) {
							if(propList.identifier == AttrCode.split('-')[0]) {
								this.DeviceAttrTypeUpdata(propList.dataType)
								if(propList.dataType.type == 'enum' || propList.dataType.type == 'bool') {
									let selectData = [];
									Object.keys(propList.dataType.specs).forEach(function(key) {
										let devObj = {};
										devObj.id = key;
										devObj.name = propList.dataType.specs[key];
										selectData.push(devObj);
									});
									this.ValueOptionsUpdata(selectData)
								}
							}
						}
					}
				})
			},

			/*数组分类*/
			ArrayMoth(aa) {
				var moth = [],
					flag = 0,
					list = aa;
				var wdy = {
					DeviceId: '',
					DeviceName: '',
					DeviceCode: '',
					productId: '',
					sur_name: ''
				}
				for(var i = 0; i < list.length; i++) {
					var az = '';
					for(var j = 0; j < moth.length; j++) {
						if(moth[j].DeviceId == list[i]['DeviceId']) {
							flag = 1;
							az = j;
							break;
						}
					}
					if(flag == 1) {
						var ab = moth[az];
						ab.sur_name.push(list[i]);
						flag = 0;

					} else if(flag == 0) {
						wdy = {};
						wdy.DeviceId = list[i]['DeviceId'];
						wdy.DeviceName = list[i]['DeviceName'];
						wdy.DeviceCode = list[i]['DeviceCode'];
						wdy.productId = list[i]['productId'];
						wdy.sur_name = new Array();
						wdy.sur_name.push(list[i]);
						moth.push(wdy);
					}
				}

				let devArr = [];
				for(var a = 0; a < moth.length; a++) {
					devArr[a] = {};
					devArr[a].DeviceId = moth[a].DeviceId;
					devArr[a].DeviceName = moth[a].DeviceName;
					devArr[a].DeviceCode = moth[a].DeviceCode;
					devArr[a].productId = moth[a].productId;
					devArr[a].attrData = [];
					for(var n = 0; n < moth[a].sur_name.length; n++) {
						devArr[a].attrData[n] = moth[a].sur_name[n].attrData;
					}
				}
				return devArr
			},

			/*名字改变*/
			NameChange(val) {
				this.revokeStorage();/*存储撤消状态*/
				this.DivNameChange(val)
			},

			/*更改焦点状态*/
			changefocus(){
				this.inputFocusChange();
			},

			/*input主动失去焦点*/
			inputBlur(){
				if(this.$refs.input){
					this.$refs.input.blur();
				}
			},

			/*组件大纲点击*/
			componentsClick(index, active) {
				if(!this.sync) {
					if(this.draggable.filter(item => item.active == true).length <= 1) {
						this.ActiveForDraggableAllFalse();
					}
				}
				this.ActiveForDraggable({
					index: index,
					Mark: !active,
				})
				//显示当前首选设备 连接点;切换当前首选状态
				this.NowActiveModifyTrue(index);
				this.currentIndexModify(index);
			},

			/*近端转接头改变*/
			NearAdapterChange(id) {
				this.revokeStorage();/*存储撤消状态*/
				if(id == this.ThisActive.NearNum) {
					/*取消近端转接头*/
					this.NearAdapterClear();
					//重新加载连接点显示
					this.AgainLodingConnectPoint();
				} else {
					this.NearAdapterUpdata(id);
					//重新加载连接点显示
					this.AgainLodingConnectPoint();
				}
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr

			},
			/*远端转接头改变*/
			FarAdapterChange(id) {
				this.revokeStorage();/*存储撤消状态*/
				if(id == this.ThisActive.FarNum) {
					/*取消远端转接头*/
					this.FarAdapterClear();
					//重新加载连接点显示
					this.AgainLodingConnectPoint();
				} else {
					this.FarAdapterUpdata(id);
					//重新加载连接点显示
					this.AgainLodingConnectPoint();
				}
				this.settingConfigChange(this.ThisActive.index)//更新当前dataAttr
			},
			/*多选时的管道控制*/
			SyncShowConduit(){
				let arr = this.draggable.filter(item => item.active == true);
				let arrConduit = arr.filter(item => item.type.indexOf('conduit') != -1);
				if(arr.length == arrConduit.length && this.SyncJudge){
					this.SyncType = 'conduit';
					let name;
					let colorId;
					let direction;
					let index = 0;
					for(let obj of arrConduit){
						if(index==0){
							name = obj.divName;
							colorId = obj.colorId;
							direction = obj.direction;
						}else{
							if(obj.divName != name){
								name = null;
							}
							if(obj.colorId != colorId){
								colorId = null;
							}
							if(obj.direction != direction){
								direction = null
							}
						}
						index++;
					}
					this.dataAttr.divName = name;
					this.dataAttr.colorId = colorId;
					this.dataAttr.direction = direction;
					this.$forceUpdate();
				}else{
					this.SyncType = null;
					this.settingsShowMark = false;
				}
			},

			/*设置*/
			settingConfigChange(index) {
				this.ThisActive = this.draggable.filter(item => item.index == index)[0];
				if(!this.ThisActive) return;
				let _v = this.ThisActive;
				// console.log(_v)
				/*dataAttr: {
					divName: '',//控件名称
					colorId: null,//控件颜色
					direction: null,//流动方向
					DeviceId: null,//控件关联设备

					showSpanName: false, //用于显示属性名称
					spanShowValue: false, //用于控制文本标签显示内容 显示控件名称or显示属性值
					DeviceMultipleArray: [],//控件关联属性 多选 用于展示
					DeviceMoth: [],//控件关联属性总列表 多选 用于程序
					DeviceBlockArray： [], //设备面板关联属性 多选
					DeviceBlockArrayShow: [], //设备面板关联属性 用于展示

					DeviceData: [],//控件关联属性 单选 用于展示
					DeviceAllAttrList: [],//存放当前所关联设备的所有属性 (错误)
					DevicePropCode： null,//控件关联属性code (attrCode + '-' + deviceCode)
					DevicePropName: null,//文本标签关联属性的名称
					DevicePropValue: null,//文本标签关联属性的值

					DeviceAlertLightColor: 'green',//控件报警提示灯颜色
					DeviceAlertLightShow: false,//控件报警指示灯开关
					DeviceAlertLight_state: 1,//控件报警提示灯状态

					DeviceStateLightColor: 'green',//控件状态指示灯颜色
					DeviceStateLightShow: false,//控件状态指示灯开关
					DeviceAttrStateID:null,//控件开关机关联属性
					DeviceAttrStateList: [],//控件开关机关联属性列表 (错误)
					DeviceStateLight_state: 1,//控件指示灯状态

					DeviceProgressLightColor: 'green',//进度条状态颜色
					DeviceProgressLightShow: false,//进度条开关
					DeviceAttrID: null,//进度条关联属性
					DeviceAttrList: [],//进度条关联属性列表 (错误)
					DeviceProgressValue: 0,//进度条当前百分比
					DeviceProgress_state: 1,//进度条当前状态

					thresholdSymbol: null,//当前阈值选择符id
					thresholdValue: null,//当前阈值输入值
				}*/
				this.dataAttr.divName = _v.divName;
				if(this.ActiveType == 'span') {
					this.dataAttr.DeviceData = _v.DeviceData;
					this.dataAttr.showSpanName = _v.showSpanName;
					this.dataAttr.spanShowValue = _v.spanShowValue;
          this.dataAttr.DeviceShowCode = _v.DeviceShowCode;
          // this.dataAttr.showAttrKey = _v.showAttrKey;
          this.dataAttr.fontSize = _v.fontSize;
          this.dataAttr.fontColor = _v.fontColor;
          this.dataAttr.bgColor = _v.bgColor;
          this.dataAttr.textShowData = _v.textShowData
          setTimeout(()=>{
            this.changeTestShow(this.dataAttr.textShowData,'spanSon2',true,_v.showAttrKey);
          },888)
				} else if(this.ActiveType == 'Divspan') {
					this.dataAttr.DeviceMultipleArray = _v.DeviceMultipleArray;

				} else if(this.ActiveType == 'conduit') {
					this.dataAttr.colorId = _v.colorId;
					this.dataAttr.DeviceData = _v.DeviceData;
					this.dataAttr.direction = _v.direction;
					if(_v.DevicePropCode!=null){
						this.dataAttr.thresholdSymbol = _v.thresholdSymbol;
						this.dataAttr.thresholdValue = _v.thresholdValue;
					}
					if(this.ThisActive.rotateDeg == -30) {
						//x轴管道

					} else if(this.ThisActive.rotateDeg == 30) {
						//y轴管道

					} else if(this.ThisActive.rotateDeg == 90) {
						//z轴管道

					}
				} else if(this.ActiveType == 'valve') {
					this.dataAttr.DeviceId = _v.DeviceId;
					this.DeviceIdChange(_v.DeviceId)
					this.dataAttr.DeviceStateLightShow = _v.DeviceStateLightShow;

				} else if(this.ActiveType == 'watch') {
					this.dataAttr.DeviceId = _v.DeviceId;
					this.DeviceIdChange(_v.DeviceId)
					this.dataAttr.DeviceStateLightShow = _v.DeviceStateLightShow;

				} else if(this.ActiveType == 'img') {
					this.dataAttr.DeviceId = _v.DeviceId;
					this.DeviceIdChange(_v.DeviceId)
					this.dataAttr.showSpanName = _v.showSpanName||false;
					//this.dataAttr.DeviceBlockArray = _v.DeviceBlockArray?_v.DeviceBlockArray:[];
					this.dataAttr.DeviceBlockArrayShow = _v.DeviceBlockArrayShow?_v.DeviceBlockArrayShow:[];
					if(_v.propertie.hasAlarmLight){
						this.dataAttr.DeviceAlertLightShow = _v.DeviceAlertLightShow;
						this.dataAttr.DeviceAttrStateID = _v.DeviceAttrStateID;
					}
					if(_v.propertie.hasStateLight){
						this.dataAttr.DeviceStateLightShow = _v.DeviceStateLightShow;
					}
					if(_v.propertie.hasProgressBar){
						this.dataAttr.DeviceProgressLightShow = _v.DeviceProgressLightShow;
						this.dataAttr.DeviceAttrID = _v.DeviceAttrID;
					}
				}
				this.$forceUpdate();
        // if(this.ActiveType == 'span'){
        //   setTimeout(()=>{
        //     this.changeTestShow(this.dataAttr.textShowData,'spanSon2');
        //   },2000)
        // }
			},


      DeviceOptions2(){
        let options = this.clone(this.DeviceOptions)
      	// for(let item of options){
       //    let arr = []
       //    for(let attr of item.children){
       //      // console.log(attr.dataType&&attr.dataType.type == 'bool')
       //      if(attr.dataType&&attr.dataType.type == 'bool'){
       //        arr.push(attr)
       //      }
       //    }
       //    item.children = arr
       //  }
        for(let i=0;i<options.length;i++){
          let arr = []
          for(let j=0;j<options[i].children.length;j++){
            if(options[i].children[j].dataType&&options[i].children[j].dataType.type == 'bool'){
              arr.push(options[i].children[j])
            }
          }
          options[i].children = arr
        }
        this.DeviceShowOptions = options
        // console.log("optios",this.DeviceShowOptions)
      }
		},
		watch: {
      colorMark(){
        if(this.colorType==1){
          var obj = {
            fontColor:this.dataAttr.fontColor
          }
          this.TextStyleData(obj)
        }else{
          var obj = {
            bgColor:this.dataAttr.bgColor
          }
          this.TextStyleData(obj)
        }
         let timer = setTimeout(()=>{
          this.$forceUpdate()
          this.$emit('updata')
		  clearTimeout(timer)
		  timer = null
        },100)
      },
      GridSettingShow(){
        console.log(this.GridSettingShow)
      },
			currentIndex(val) {
				if(val == -1){
					/*
					 * 没选中设备时
					 */
					this.ThisActive = {};
					this.settingsShowMark = false;
					this.ActiveType = null;
					this.SyncJudge = false;
					this.SyncType = null;

				}else if(val) {
					/*
					 * 选中设备时
					 */

					//当前是否处于多选状态 是则true 否则false
					this.SyncJudge = this.draggable.filter(item => item.active == true).length == 1 ? false : true;

					if(!this.SyncJudge) {
						/*
						 * 不处于多选状态时
						 */

						//属性配置面板是否展示
						this.settingsShowMark = true;
						//当前选中控件的类型
						this.ActiveType = this.draggable.filter(item => item.active == true)[0].type;
						if(this.ActiveType == 'conduit-30' || this.ActiveType == 'conduit30' || this.ActiveType == 'conduit90' || this.ActiveType == 'conduit0') {
							this.ActiveType = 'conduit'
						}
						this.SyncJudge = false;
						this.SyncType = null;

						//更新属性面板参数
						this.settingConfigChange(val);
					} else {
						/*
						 * 处于多选状态时
						 */
						//属性配置面板是否展示
						this.settingsShowMark = true;
						//配置多选时的管道属性控制
						this.ThisActive = {};
						this.SyncShowConduit();
					}
				} else if(val == null){
					/*鼠标框选多选*/

					//当前是否处于多选状态 是则true 否则false
					this.SyncJudge = true;
					//属性配置面板是否展示
					this.settingsShowMark = true;
					//配置多选时的管道属性控制
					this.ThisActive = {};
					this.SyncShowConduit();

				}

			},

			/*监听设备id变化 重新获取所有属性列表*/
			monitorDeviceId(val){
				//this.DeviceIdChange(val)
			},
			ThisActive(){
				// console.log(this.ThisActive)
			},
		}
	}
</script>
<style scoped>
	.dis{
		cursor: not-allowed !important;
	}
	.el-form-item__errorMy.active {
		opacity: 1;
		transform: scaleY(1);
		height: auto;
	}

	.el-form-item__errorMy {
		color: #e41616;
		font-size: 12px;
		padding-top: 4px;
		position: relative;
		top: 100%;
		left: 0px;
		transition: .3s;
		line-height: 14px;
		opacity: 0;
		overflow: hidden;
		text-align: left;
		transform: scaleY(0);
		height: 0;
	}

	.attrBottom {
		margin-bottom: 10px;
	}

	.stateLight {
		text-align: left;
		position: relative;
		top: 14px;
	}

	.content_body>>>.el-switch.is-checked .el-switch__core::after {
		left: 100%;
		margin-left: -17px;
	}

	.content_body>>>.el-switch__core:after {
		width: 18px;
		height: 18px;
		top: 0px;
		left: 0px;
	}

	.content_body>>>.el-switch__core {
		border: 1px solid #757575;
		background: #141414;
	}

	.content_body>>>.el-switch.is-checked .el-switch__core {
		border-color: #2571EF;
		background-color: #2571EF;
	}

	.NowNearBg {
		background-position: center;
		background-repeat: no-repeat;
	}

	.NowFarBg {
		background-position: center;
		background-repeat: no-repeat;
	}

	.boxChildren_name {
		color: #DADADA;
		position: absolute;
		width: 100%;
		text-align: center;
		bottom: 3px;
		font-size: 12px;
		transform: scale(0.8);
		letter-spacing: 1px;
	}

	.ShowConduit {
		position: absolute;
		width: 204px;
		height: 210px;
		background-color: #353738;
		padding-top: 20px;
		padding-left: 20px;
		border: 1px solid rgba(112, 112, 112, .8);
		overflow-y: auto;
		overflow-x: hidden;
		z-index: 99;
		padding-right: 7px;
	}

	.NearEnd {
		top: 115px;
		left: -10px;
	}

	.FarEnd {
		top: 115px;
		left: -140px;
	}

	.ShowConduit_body {
		width: 207px;
		height: auto;
	}

	.ConduitChoiceBox {
		float: left;
		width: 53px;
		height: 53px;
		outline: 2px solid rgba(112, 112, 112, .6);
		margin-right: 13.8px;
		margin-bottom: 17px;
		background-position: center 8px;
		background-repeat: no-repeat;
		position: relative;
		cursor: pointer;
	}

	.ConduitChoiceBox.active {
		outline: 2px solid rgba(37, 113, 239, 1);
	}

	.ConduitChoiceBox:hover {
		outline: 2px solid rgba(37, 113, 239, 1);
	}

	.ShowConduit::-webkit-scrollbar {
		width: 10px;
	}

	.ShowConduit::-webkit-scrollbar-button:start {
		background: url(../../../assets/image/editor/icon/top.png)no-repeat 1px center;
		width: 10px;
		height: 10px;
	}

	.ShowConduit::-webkit-scrollbar-button:end {
		background: url(../../../assets/image/editor/icon/bottom.png)no-repeat 1px center;
		width: 10px;
		height: 10px;
	}

	.ShowConduit::-webkit-scrollbar-track {
		background: rgba(32, 33, 34, 1);
		width: 11px;
	}

	.ShowConduit::-webkit-scrollbar-thumb {
		cursor: pointer;
		background: rgba(119, 120, 120, 1);
		width: 11px;
	}

	.conduit_css_body img {
		position: absolute;
		top: 0;
		bottom: 0;
		margin: auto;
		right: 18px;
		transition: .3s;
	}

	.css_body_box {
		width: 68px;
		height: 68px;
		border: 1px solid rgba(112, 112, 112, .8);
		text-align: center;
		float: left;
	}

	.conduit_css {
		width: 112px;
		height: 127px;
		float: right;
		position: relative;
	}

	.conduit_css_name {
		width: 100%;
		float: left;
		line-height: 40px;
		text-indent: 15px;
		color: #FFFFFF;
		text-align: left;
		font-size: 12px;
	}

	.conduit_css_body {
		width: calc(100% - 15px);
		padding-left: 15px;
		/*margin-bottom: 15px;*/
		height: 70px;
		line-height: 68px;
		cursor: pointer;
		position: relative;
		float: left;
	}

	.tranRotate {
		transform: rotate(90deg) !important;
	}

	.settings_box_content .content_body>>>.el-cascader .el-input__inner {
	    height: 37px !important;
	}

	.content_body>>>.el-cascader .el-cascader__tags span:first-child span:first-child {
		max-width: 40px;
		text-indent: 2.5px;
	}

	.content_body>>>.el-cascader .el-cascader__tags span:first-child i {
		left: 0px;
		top: 1.4px;
		background-color: #252626 !important;
		border: 1px solid rgba(112, 112, 112, .8);
		text-indent: -1px;
		line-height: 16px;
	}

	.settings_box_content .content_body>>>.el-cascader {
		/*margin-top: 10px;*/
		line-height: unset;
		position: relative;
    	top: 6px;
		cursor: pointer;
	}

	.content_body>>>.el-cascader .el-cascader__tags .el-tag:not(.is-hit) {
		margin: 0;
		padding: 0px;
		border-radius: 1px;
		margin-left: 5px;
		background-color: #252626;
		border: 1px solid rgba(112, 112, 112, .8);
		cursor: pointer;
		margin-bottom: 1px;
	}

	.settings .settings_body .settings_box.span .settings_box_content {
		float: left;
		width: 100%;
		height: auto;
		border-bottom: 1px solid #151515;
	}

	.settings_box.span .settings_box_content .content_name {
		line-height: 50px;
		height: 50px;
		color: #FFFFFF;
		text-align: right;
		font-size: 12px;
		width: 101px;
		float: left;
	}

	.settings_box.span .settings_box_content .content_body {
		width: 125px;
		height: 50px;
		float: right;
		position: relative;
		right: 15px;
	}

	.settings_box.span .settings_box_content .content_body .el-input {
		margin-top: 11px !important;
	}

	.settings_box.span .settings_box_content>>>.el-select {
		margin-top: 11px;
	}

	.settings_box.span .settings_box_content>>>.el-input__suffix .el-input__icon {
		line-height: 30px;
		font-size: 12px;
	}

	.settings_box.span .settings_box_content .content_body>>>.el-input input {
		background-color: #252626;
		border: 1px solid rgba(67, 67, 67, 1);
		color: #fff;
		border-radius: 1px;
		width: 132px;
		height: 30px;
		font-size: 1px;
		line-height: 30px;
	}

	.settings_box.span .settings_box_content .content_body .content_body_span {
		width: 100%;
		height: 100%;
		color: #fff;
		font-size: 13px;
		line-height: 50px;
		text-align: left;
		text-indent: 5px;
		letter-spacing: 1px;
	}

	.settings {
		height: 670px;
	    width: 255px;
	    position: relative;
	    overflow-y: auto;
	    overflow-x: hidden;
	    border-top: 1px solid #151515;
	}

	.settings .settings_body {
		width: 255px;
		height: auto;
		position: relative;
	}

	.settings .settings_body .settings_box {
		width: 255px;
		height: auto;
		position: relative;
	}

	.settings::-webkit-scrollbar {
		width: 10px;
	}

	.settings::-webkit-scrollbar-button:start {
		background: url(../../../assets/image/editor/icon/top.png)no-repeat 1px center;
		width: 10px;
		height: 10px;
	}

	.settings::-webkit-scrollbar-button:end {
		background: url(../../../assets/image/editor/icon/bottom.png)no-repeat 1px center;
		width: 10px;
		height: 10px;
	}

	.settings::-webkit-scrollbar-track {
		background: rgba(32, 33, 34, 1);
		width: 11px;
	}

	.settings::-webkit-scrollbar-thumb {
		cursor: pointer;
		background: rgba(119, 120, 120, 1);
		width: 11px;
	}

	.components {
	    height: calc(100% - 671px);
	    width: 100%;
	    background-color: #252626;
	    /* border-top: 1px solid #151515; */
	    color: #DADADA;
	    text-align: left;
	    text-indent: 19px;
	    font-size: 12px;
	    position: absolute;
    	bottom: 0;
	}
	.components .drag_top{
		width: 100%;
	    height: 1px;
	    border-bottom: 3px solid #151515;
	    position: absolute;
	    top: 0;
	    cursor: n-resize;
	}
	.components .components_header {
		line-height: 42px;
		height: 42px;
		float: left;
		width: 100%;
		border-bottom: 1px solid #151515;
	}

	.components .components_body {
		width: 100%;
		/*height: 169px;*/
		overflow-y: auto;
		overflow-x: hidden;
		position: absolute;
		top: 44px;
		bottom: 0;
	}

	.components .components_name {
		height: 32px;
		line-height: 32px;
		border-bottom: 1px solid #151515;
		cursor: pointer;
		font-size: 12px;
		text-indent: 30px;
	}

	.components .components_name.active {
		background-color: #2571EF;
	}

	.components .components_name:hover {
		background-color: #2571EF;
	}

	.components .components_body::-webkit-scrollbar {
		width: 10px;
	}

	.components .components_body::-webkit-scrollbar-button:start {
		background: url(../../../assets/image/editor/icon/top.png)no-repeat 1px center;
		width: 10px;
		height: 10px;
	}

	.components .components_body::-webkit-scrollbar-button:end {
		background: url(../../../assets/image/editor/icon/bottom.png)no-repeat 1px center;
		width: 10px;
		height: 10px;
	}

	.components .components_body::-webkit-scrollbar-track {
		background: rgba(32, 33, 34, 1);
		width: 11px;
	}

	.components .components_body::-webkit-scrollbar-thumb {
		cursor: pointer;
		background: rgba(119, 120, 120, 1);
		width: 11px;
	}

	.el-input {
		margin-top: 15px !important;
	}

	.attribute {
		width: 255px;
		/* height: 937px; */
		background-color: #252626;
		position: absolute;
		/* z-index: 10; */
		right: 0;
		bottom: 0;
		top: 54px;
	}

	.attribute .attribute_body {
		width: 100%;
		height: 100%;
		position: relative;
	}

	.attribute .attribute_body .attribute_content {
		float: left;
		width: 100%;
		height: 100px;
		margin-bottom: 1px;
	}

	.attribute .attribute_body .attribute_content .attribute_box {
		margin-top: 25px;
		font-size: 16px;
	}

	.button {
		border: 1.5px solid #CA3A45;
		border-radius: 3px;
		color: #CA3A45;
		width: 65px;
		height: 30px;
		cursor: pointer;
		background-color: #fff;
		font-size: 13px;
		-webkit-transition: .1s;
		transition: .1s;
		position: relative;
		margin: 20px 0 20px 20px;
		line-height: 30px;
		float: left;
	}

	.button:hover {
		background-color: #CA3A45;
		color: #fff;
	}

  .vueColor {
    width: 200px;
    height: 300px;
  	position: fixed;
  	z-index: 9999;
  }
  .color-span{
    position: relative;
    top: 5px;
    border: 1px solid #434343;
    width: 30px;
    height: 20px;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/MapEditor/attribute/attribute.vue